(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ssc-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.ssc-about');
    if (!sections.length || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.ssc-about .reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: .12 });
    sections.forEach(function (sec) {
      sec.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    });
  })();

  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-about');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function playVideo(slide) {
      var v = slide.querySelector('video');
      if (!v) return;
      try { v.currentTime = 0; } catch (e) {}
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function pauseVideo(slide) {
      var v = slide.querySelector('video');
      if (v) v.pause();
    }
    function init(el) {
      var slides = el.querySelectorAll('.ssc-hero__bg');
      var dots = el.querySelectorAll('[data-ssc-dot]');
      if (!slides.length) return;

      // Kick off the first slide's video (browsers normally autoplay muted videos,
      // but we call play() explicitly to cover edge cases).
      playVideo(slides[0]);

      if (slides.length <= 1) return;

      var idx = 0;
      var timer;
      function go(i) {
        pauseVideo(slides[idx]);
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
        playVideo(slides[idx]);
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === idx);
          if (n === idx) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
      function start() { stop(); timer = setInterval(function () { go(idx + 1); }, 4200); }
      function stop() { if (timer) clearInterval(timer); }
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          go(parseInt(d.getAttribute('data-ssc-dot'), 10));
          start();
        });
      });
      start();
    }
    document.querySelectorAll('[data-ssc-hero]').forEach(init);
  })();

  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-hero');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-instagram"] && !Shopify.designMode) return;
  try {
    

  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-ig');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-next-event"] && !Shopify.designMode) return;
  try {
    

  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-event');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-past"] && !Shopify.designMode) return;
  try {
    
  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-past');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssc-upcoming"] && !Shopify.designMode) return;
  try {
    

  // === SSC-ANIM-JS-BEGIN ===
  (function () {
    var sections = document.querySelectorAll('.ssc-sched');
    if (!sections.length) return;
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('[data-reveal]');
      if (!items.length) return;
      if (prefersReduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    });
  })();
  // === SSC-ANIM-JS-END ===

  } catch(e) { console.error(e); }
})();
})();
